export const config = {
  auth_server: '/api/user',
  client_server: '/api/client',
  account_server: '/api/account',
  serviceprovider_server: '/api/serviceproviders',
  fund_server: '/api/fund',
  transaction_server: '/api/transaction',
  transactiontype_server: '/api/transactiontype',
  housemodel_server: '/api/housemodel',
  product_server: '/api/product',
  role_server: '/api/role',
  userFunction_server: '/api/userfunction',
  entity_server: '/api/entity',
  calculation_server: '/api/calculations',
  communication_server: '/api/communication',
  file_server: '/api/files',
  mdd: '/api/mdd'
};
